import { render } from "./PageHeader.vue?vue&type=template&id=3a8598f3&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"

import "./PageHeader.vue?vue&type=style&index=0&id=3a8598f3&lang=scss&scoped=true"

import exportComponent from "D:\\projectAll\\DefectiveProduct\\BOSS_DPS\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a8598f3"]])

export default __exports__